<template>
  <v-container>
    <v-navigation-drawer
      app
      fixed
      left
      permanent
      clipped
      dark
      class="navigation-drawer-left elevation-2">
      <speeches-list></speeches-list>
      <v-list>
        <v-list-item link dark class="btn-add ma-4" @click="addSpeech">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Создать
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-row justify="center">
      <v-col cols="10">
        <v-card flat>
          <template v-if="$store.getters.selectActiveSpeech">
            <s-blocks-list :s-blocks-array="activeSpeech"></s-blocks-list>
          </template>
          <template v-else>
            <v-card flat>
              <v-card-subtitle>Ничего не выбрано</v-card-subtitle>
            </v-card>
          </template>
        </v-card>
      </v-col>
    </v-row>
    <v-navigation-drawer
      app
      fixed
      right
      permanent
      clipped
      light
      class="navigation-drawer-right elevation-2">
      <template v-if="$store.getters.selectActiveSpeech">
        <speech-meta :active-speech="activeSpeechMeta"></speech-meta>
        <v-list>
          <v-list-item link dark class="btn-save ma-4" @click="saveSpeech">
            <v-list-item-icon>
              <v-icon>mdi-content-save</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Сохранить
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link dark class="btn-delete ma-4" @click="deleteSpeech">
            <v-list-item-icon>
              <v-icon>mdi-delete-forever</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Удалить
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
      <template v-else>
        <v-subheader>Ничего не выбрано</v-subheader>
      </template>
    </v-navigation-drawer>
  </v-container>

</template>

<script>
import SBlocksList from '../components/constructor/SBlocksList'
import SpeechesList from '../components/constructor/SpeechesList'
import SpeechMeta from '../components/constructor/SpeechMeta'
export default {
  name: 'SpeechConstructor',
  components: {
    SpeechMeta,
    SpeechesList,
    SBlocksList
  },
  data () {
    return {
      test: [
      ]
    }
  },
  computed: {
    activeSpeech: ({ $store }) => {
      return $store.getters.ActiveSpeech.speech
    },
    activeSpeechMeta: ({ $store }) => {
      const as = $store.getters.ActiveSpeech
      const speechMeta = {
        name: as.name,
        description: as.description,
        created_at: as.created_at,
        updated_at: as.updated_at
      }
      return speechMeta
    }
  },
  methods: {
    saveSpeech () {
      this.$store.dispatch({
        type: 'updateActiveSpeech',
        metaSpeech: this.activeSpeechMeta,
        speech: this.activeSpeech
      })
    },
    deleteSpeech () {
      this.$store.dispatch({
        type: 'deleteActiveSpeech'
      })
    },
    addSpeech () {
      this.$store.dispatch({
        type: 'addNewSpeech'
      })
    }
  },
  created () {
    this.$store.dispatch({
      type: 'initialSpeech',
      root: true
    })
    this.$store.dispatch({
      type: 'getSBlockType'
    })
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/colors';
  .navigation-drawer-left,
  .btn-save,
  .btn-add {
    background-color: $itmo-blue!important;
  }
  .navigation-drawer-right {
    background-color: whitesmoke!important;
  }
  .btn-delete {
    background-color: $itmo-red!important;
  }
  .btn-save,
  .btn-delete {
    border-radius: 20px;
  }

</style>
